import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import PlusIcon from "app/components/Icons/PlusIcon";
import clsx from "clsx";
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import AddNew from "./AddNew";
import HeaderArea from "./HeaderArea";
import MenuTile from "./MenuTile";
import { selectIsSelectedId } from "./redux/selector";
import { ITags, MenuItemsProps } from "./types";
import UpdateName from "./UpdateName";
import { isInsideRadixPopover } from "./helper";

const MenuItems: React.FC<MenuItemsProps<ITags[]>> = ({
  options,
  menuContentClassName,
  className,
  searchPlaceholder,
  onChange,
  align = "start",
  dropdownWidth,
  selectedIds,
  headingText,
  isFullWidth,
  projectId,
  onDeleteRequest,
}) => {
  const selectedTagId = useSelector(selectIsSelectedId);

  const [showSelectColor, setShowSelectColor] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [search, setSearch] = useState("");

  function searchFilters(tags: ITags[], keyword: string): ITags[] {
    if (!keyword || !tags) {
      return tags ? tags : [];
    }
    const lowerCaseKeyword = keyword.toLowerCase();

    return tags?.filter((tag) => {
      return tag.title.toLowerCase().includes(lowerCaseKeyword);
    });
  }
  const filteredTags = searchFilters(options, search);
  const isAllSelected =
    Array.isArray(selectedIds) && selectedIds.length === options.length;
  const handleSelectAll = () => {
    const allIds = options.map((item) => item._id);
    onChange(allIds);
  };
  const handleSelect = (tag: ITags) => {
    let updatedIds: string[] = [];
    updatedIds = [tag._id];
    onChange(updatedIds);
  };

  const preventDismissForPopover = (e: Event) => {
    if (isInsideRadixPopover(e.target)) {
      e.preventDefault();
    }
  };

  return (
    <DropdownMenu.Content
      align={align}
      sideOffset={5}
      side="bottom"
      style={{ width: isFullWidth ? dropdownWidth : undefined }}
      className={`bg-white shadow-lg rounded-md z-50 w-64 border border-gray-100 py-2 overflow-hidden ${className}`}
      onPointerDownOutside={preventDismissForPopover}
      onFocusOutside={preventDismissForPopover}
    >
      <HeaderArea
        handleSelectAll={handleSelectAll}
        isAllSelected={isAllSelected}
        setSearch={setSearch}
        search={search}
        headingText={headingText as string}
        placeholder={searchPlaceholder as string}
        showIsSelected={options?.length > 0 ? true : false}
      />
      <div
        className={clsx("overflow-auto max-h-[200px] ", menuContentClassName)}
        ref={ref}
      >
        {filteredTags?.map((opt) => {
          const isArray = Array.isArray(selectedIds);
          const isEdit = selectedTagId === opt._id;
          const isSelected = isArray
            ? selectedIds.includes(opt._id)
            : selectedIds === opt._id;
          return isEdit ? (
            <UpdateName />
          ) : (
            <MenuTile
              opt={opt}
              isSelected={isSelected}
              handleSelect={handleSelect}
              onDeleteRequest={onDeleteRequest}
            />
          );
        })}
      </div>
      <AddNew
        trigger={
          <button className="w-full flex items-center border-t h-[50px] py-3 px-2 gap-3 border-gray-100 ">
            <div
              className={clsx(
                " w-full px-2 flex items-center text-sm text-primary font-medium hover:bg-gray-400 h-[38px] rounded gap-2 ",
                showSelectColor && " !border border-secondary ",
              )}
            >
              <PlusIcon color="#5A8DF1" size={20} />
              New tag
            </div>
          </button>
        }
        projectId={projectId}
        open={showSelectColor}
        setOpen={setShowSelectColor}
      />
    </DropdownMenu.Content>
  );
};

export default MenuItems;
